import type { PageProps } from 'gatsby';
import React from 'react';

import MfaForm from '@views/Authentication/Mfa/MfaForm';

function MfaPage({ params }: PageProps) {
  return <MfaForm {...params} />;
}

export default MfaPage;
